import React from "react";
import { AttributeCollection, getNodeComponentAttributeValue } from "../Definitions/LayoutNode";


export const defaultCookieBannerText = "We use cookies to provide you with a great experience and to help our website run effectively. By accepting, you agree to our use of cookies."

export default function RenderCookieBanner({node,isPublish}:{node:AttributeCollection,isPublish?:boolean}){


    const tempDesc =  getNodeComponentAttributeValue(node,"cookieBannerText","");
    const tempBtnMessage = "Accept";

    let isDisabled = getNodeComponentAttributeValue(node,"cookieBannerOn","") == "off";

    if(isDisabled){
        return null;
    }

    let colorSetting = getNodeComponentAttributeValue(node,"cookieBannerColorSetting","");

    let isCustom = colorSetting == "custom";

    let bgColor = "#333333";
    let txtColor = "white";
    let btnClass = "";
    let pCalss = "";

    if(colorSetting == "light"){
        bgColor = "white";
        txtColor = "#333333";

    }
    else if(isCustom){
        bgColor = getNodeComponentAttributeValue(node,"cookieBannerBgColor","white");
        txtColor = getNodeComponentAttributeValue(node,"cookieBannerTxtColor","#333333");
        btnClass = "v-button "+getNodeComponentAttributeValue(node,"cookieBannerBtnStyle","primary");
        pCalss = getNodeComponentAttributeValue(node,"cookieBannerTextStyle","vp-1");
        //grab the custom value;
    }


 



    return <div id="vwb-cookie-banner" className=" vanimation-fade-in-up flex-row-to-column-475 align-center v-site block-edit"

    style={{position:(isPublish?"fixed":"absolute"),left:"0",bottom:"0",zIndex:100000,width:"100%",padding:"4px 12px 4px 12px",background:bgColor,color:txtColor,animationDuration:".8s",animationDelay:"0s"}}>

        <div className={"w-full "+pCalss } style={{padding:"12px 12px",color:txtColor}} data-nosnippet="data-nosnippet"  dangerouslySetInnerHTML={{__html: tempDesc}}></div>
        <button id="decline-cookie-banner" className={"invisible-button full-width-475  v-button secondary" }style={isCustom?{margin:"12px"}:{border:"1px solid "+txtColor,background:bgColor,color:txtColor,padding:"10px 16px",borderRadius:"4px",margin:"12px"}}>Decline</button>
        <button id="accept-cookie-banner" className={"invisible-button full-width-475 "+btnClass }style={isCustom?{margin:"12px"}:{background:txtColor,color:bgColor,padding:"10px 16px",borderRadius:"4px",margin:"12px"}}>{tempBtnMessage}</button>
      
        <div className="top-right-475">
            <button id="dismiss-cookie-banner" className="center-all invisible-button " style={{fontSize:"32px",width:"40px",fontFamily:"monospace",color:txtColor,background:"none"}}>&times;</button>
        </div>

    </div>

}